export default {
  CANCEL_ACCOUNT_REPOSITORY: Symbol.for('CANCEL_ACCOUNT_REPOSITORY'),
  CANCEL_ACCOUNT_COMMAND: Symbol.for('CANCEL_ACCOUNT_COMMAND'),
};
